module.exports = __webpack_public_path__ + "twoCover.eac5439781e58e9811ec.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/two/twoCover.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/two/twoCover.jpg
// module chunks = 0